import * as React from "react";
import { IMetricOptions, IMetricData } from "@curefit/metrics";
import { UserGoalView, Goal } from "@curefit/gmf-common";
import AppLoader from "../../components/utils/AppLoader";
import {default as AppUtils, EpochConstants, LOADING_STATE} from "../../utils/AppUtils";
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard";
import * as _ from "lodash";
import ModelFactory from "../../models/ModelFactory";
import IMetric from "../../models/metrics/IMetric";
import ErrorContainer from "./../ErrorContainer";
import ILifestyleGoal from "../../models/gms/ILifestyleGoal";

interface HealthTargetsEditViewProps {
    goalsType?: string;
    doctorId?: number;
    appointmentId?: number;
    patientId: number,
    secondaryUserId: string,
    patientGoals: UserGoalView[],
    staticGoals: Goal[],
    staticMetrics: IMetric[],
    fetchPlanStaticData: () => void,
    fetchPatientAllergies?: (patientId: number) => any,
    savePatientGoalsEdit?: (patientId: number, req: any) => any,
    displayMode?: EditViewDisplayMode,
    titleToDisplay?: string,
    preventGoalAddition?: boolean,
    addUserMetric: (metricId: string, metricValue: number) => Promise<any>;
    getUserMetrics: (req: IMetricOptions) => void;
    patientMetrics: {[metricId: number]: IMetricData[]}
    isSelf: boolean;
    showActionIcons?: boolean;
    setAssessmentMetric?: (metricId: string) => void
}
interface HealthTargetsEditViewStates {
    updatedGoals: {item: UserGoalView}[];
    isStaticGoalsAndMetricsLoaded: LOADING_STATE;
    isHealthTargetDataLoaded: LOADING_STATE;
    error: string;
    errorDetails: string;
    isEdited?: boolean;
}
export default class HealthTargetsEditViewCont extends React.Component<HealthTargetsEditViewProps, HealthTargetsEditViewStates> {
    constructor(props: HealthTargetsEditViewProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(newProps: HealthTargetsEditViewProps) {
        this.setState(this.getStateFromProps(newProps));
    }

    getUserUpdatedMetrics = (metricId: number) => {
        let userMetricReq = ModelFactory.createUserMetricReqObject(this.props.patientId.toString(), this.props.secondaryUserId, Number(metricId), this.props.isSelf);
        userMetricReq.sortDesc = true;
        this.props.getUserMetrics(userMetricReq);
    };

    getUpdatedGoalsFromProps = (props: HealthTargetsEditViewProps): {item: UserGoalView}[] => {
        let currUpdatedAllergies: {item: UserGoalView}[] = []
        _.map(props.patientGoals, function(patientGoal){
            // if (_.isEmpty(patientGoal._id)) {
                let clonePatientGoal = Object.assign({}, patientGoal)
                currUpdatedAllergies.push({item: clonePatientGoal})
            // }
        })
        return currUpdatedAllergies
    }
    getUpdatedSavedGoalsFromProps = (props: HealthTargetsEditViewProps): {item: UserGoalView}[] => {
        let currUpdatedAllergies: {item: UserGoalView}[] = []
        _.map(props.patientGoals, function(patientGoal){
            if (!_.isEmpty(patientGoal._id)) {
                let clonePatientGoal = Object.assign({}, patientGoal)
                currUpdatedAllergies.push({item: clonePatientGoal})
            }
        })
        return currUpdatedAllergies
    }
    getStateFromProps = (props: HealthTargetsEditViewProps) => {
        let currState: HealthTargetsEditViewStates = {
            updatedGoals: [],
            isHealthTargetDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            isStaticGoalsAndMetricsLoaded: _.isEmpty(this.state) ? LOADING_STATE.NOT_INITIALIZED : this.state.isStaticGoalsAndMetricsLoaded,
            error: "",
            errorDetails: "",
            isEdited: false
        }
        if ( _.isNull(props.patientGoals) ) {
            props.fetchPatientAllergies(this.props.patientId)
            currState.isHealthTargetDataLoaded = LOADING_STATE.LOADING
        } else {
            currState.updatedGoals = [];
            if (AppUtils.isDefined(this.state) && AppUtils.isDefined(this.state.updatedGoals)) {
                currState.updatedGoals = this.state.updatedGoals;
            } else {
                _.map(props.patientGoals, function(patientGoal){
                    let clonePatientGoal = Object.assign({}, patientGoal)
                    if (!_.isEmpty(patientGoal.editInfo) && !_.isEmpty(patientGoal.editInfo.nextGoalMetricTargets)) {
                        clonePatientGoal.goalMetricTargets = patientGoal.editInfo.nextGoalMetricTargets;
                    }
                    currState.updatedGoals.push({item: clonePatientGoal})
                })
            }
            currState.isHealthTargetDataLoaded = LOADING_STATE.LOADED
        }

        if ((_.isEmpty(props.staticGoals) || _.isEmpty(props.staticMetrics)) &&
            currState.isStaticGoalsAndMetricsLoaded === LOADING_STATE.NOT_INITIALIZED) {
            this.props.fetchPlanStaticData();
            currState.isStaticGoalsAndMetricsLoaded = LOADING_STATE.LOADING;
        } else {
            if (!_.isEmpty(props.staticGoals) && !_.isEmpty(props.staticMetrics)) {
                currState.isStaticGoalsAndMetricsLoaded = LOADING_STATE.LOADED;
            }
        }
        return currState
    }
    getHealthTargetEditViewProps = () => {
        let healthTargetViewProps = {
            goalsType: this.props.goalsType,
            staticGoals: this.props.staticGoals,
            staticMetrics: this.props.staticMetrics,
            updatedGoals: this.state.updatedGoals,
            updateGoals: this.updateGoals,
            isOnlyEdit: this.props.preventGoalAddition,
            patientMetrics: this.props.patientMetrics
        };
        let healthTargetEditProps = {
            goalsType: this.props.goalsType,
            staticGoals: this.props.staticGoals,
            staticMetrics: this.props.staticMetrics,
            updatedGoals: this.state.updatedGoals,
            updateGoals: this.updateGoals,
            isOnlyEdit: this.props.preventGoalAddition,
            addUserMetric: this.props.addUserMetric,
            patientMetrics: this.props.patientMetrics,
            getUserUpdatedMetrics: this.getUserUpdatedMetrics,
            patientId: this.props.patientId,
            secondaryUserId: this.props.secondaryUserId,
            isSelf: this.props.isSelf,
            patientAllSavedMetrics: this._getAllSavedMetrics(),
            setAssessmentMetric: this.props.setAssessmentMetric
        };
        return {view: healthTargetViewProps, edit: healthTargetEditProps};
    }

    _getAllSavedMetrics = () => {
        const patientGoals = this.props.patientGoals || [];
        let allSavedMetrics: ILifestyleGoal[] = [];
        patientGoals.map(goal => {
            if (!_.isEmpty(goal.goalMetricTargets)) {
                goal.goalMetricTargets.map(metric => {
                    allSavedMetrics.push(metric);
                })
            }
        })
        return allSavedMetrics;
    }

    updateGoals = (updatedGoals: {item: UserGoalView}[]) => {
        this.setState({updatedGoals: updatedGoals, isEdited: true})
    }
    /*cancelSavedActionHandler = () => {
        this.setState({savedGoals: this.getUpdatedSavedGoalsFromProps(this.props)})
    }*/
    cancelActionHandler = () => {
        this.setState({updatedGoals: this.getUpdatedGoalsFromProps(this.props), isEdited: false})
    }
    saveHealthTarget = () => {
        let myInstance = this;
        let healthTargetSource = {
            serviceId: "DOCSAPP",
            serviceRefId: `CONS-${this.props.appointmentId}`,
            userType: "DOCTOR",
            userRefId: this.props.doctorId.toString()
        }
        let nextStatus = !_.isEmpty(this.state.updatedGoals[0].item.editInfo) && !_.isEmpty(this.state.updatedGoals[0].item.editInfo.nextStatus) &&
                            this.state.updatedGoals[0].item.editInfo.nextStatus === "CANCELLED" ? "CANCELLED" : "LIVE";
        let healthTargetSaveObject = {
            source: healthTargetSource,
            userGoalEdits: [{
                userGoalId: this.state.updatedGoals[0].item._id,
                editInfo: {
                    nextStatus,
                    nextGoalMetricTargets: this.state.updatedGoals[0].item.goalMetricTargets
                }
            }]
        }
        if (!this.isFormDirty()) {
            this.setState({isHealthTargetDataLoaded: LOADING_STATE.NOT_INITIALIZED}, () => {
                this.props.savePatientGoalsEdit(this.props.patientId, healthTargetSaveObject).then(function(updatedGoals: UserGoalView[]){
                    let clonePatientGoal = Object.assign({}, updatedGoals[0]);
                    if (!_.isEmpty(clonePatientGoal.editInfo) && !_.isEmpty(clonePatientGoal.editInfo.nextGoalMetricTargets)) {
                        clonePatientGoal.goalMetricTargets = clonePatientGoal.editInfo.nextGoalMetricTargets;
                    }
                    myInstance.setState({isHealthTargetDataLoaded: LOADING_STATE.LOADED, isEdited: false, updatedGoals: [{item: clonePatientGoal}]})
                }).catch((error: any) => {
                    this.setState({
                        error: "Could not save Health Targets",
                        errorDetails: error.message,
                        isHealthTargetDataLoaded: LOADING_STATE.LOADED
                    })
                })
            });
        } else {
            let dirtyFormText = myInstance.dirtyFormText();
            this.setState({
                error: "Goals validation failed",
                errorDetails: dirtyFormText
            })
        }
    }
    isFormDirty = (): boolean => {
        let status = false;
        let erronousRows: number[] = [];
        let goalType = this.props.goalsType;
        _.map(this.state.updatedGoals, function(updateGoalItem: {item: UserGoalView}, index: number){
            if (!ModelFactory.isValidGoal(updateGoalItem.item, goalType)) {
                status = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        return status;
    }

    dirtyFormText = (): string => {
        let erronousRows: number[] = [];
        let errorText = `Please fill in a valid goal`;
        let goalType = this.props.goalsType;
        _.map(this.state.updatedGoals, function(updatedGoalItem: {item: UserGoalView}, index: number){
            if (!ModelFactory.isValidGoal(updatedGoalItem.item, goalType)) {
                erronousRows.push(index + 1);
                if (!_.isEmpty(updatedGoalItem.item.goalId)) {
                    if (_.isEmpty(updatedGoalItem.item.goalMetricTargets)) {
                        errorText = `Please fill in a valid metric for ${updatedGoalItem.item.goalName} goal`
                    } else {
                        _.map(updatedGoalItem.item.goalMetricTargets, (metric: ILifestyleGoal) => {
                            let targetErrorText = ModelFactory.isTargetRangeNotValid(metric.idealValue, false);
                            if (!AppUtils.isDefined(metric.metricId)) {
                                errorText = `Please fill in a valid metric for ${updatedGoalItem.item.goalName} goal`
                            } else if (!AppUtils.isDefined(metric.currentValue.value) || metric.currentValue.value === "" as any) {
                                errorText = `Please fill in a valid initial value for ${updatedGoalItem.item.goalName} goal`
                            } else if (_.isEmpty(metric.trackingFreq.unit)) {
                                errorText = `Please fill in a valid frequency for ${updatedGoalItem.item.goalName} goal`
                            } else if (!AppUtils.isDefined(metric.aim)) {
                                errorText = `Please fill in the aim for ${updatedGoalItem.item.goalName} goal`
                            } else if (!ModelFactory.isValidGoalTarget(metric.idealValue)) {
                                errorText = `Please fill in either target or range for ${updatedGoalItem.item.goalName} goal`
                            } else if (AppUtils.isDefined(targetErrorText)) {
                                errorText = `For ${updatedGoalItem.item.goalName} goal, ${targetErrorText}`
                            } else if (!ModelFactory.isMilestonesListNotEmpty(metric.targets)) {
                                errorText = `Please fill in at least one milestone for ${updatedGoalItem.item.goalName} goal`
                            }
                        })
                    }
                }
                return false;
            }
        })
        return errorText;
    }
    getSaveObject = () => {
        let isSelf = this.props.isSelf;
        let secondaryUserId = this.props.secondaryUserId;
        let goalsType = this.props.goalsType;
        let saveGoalList: UserGoalView[] = [];
        const isSavedGoal = this.state.updatedGoals.length && !_.isEmpty(this.state.updatedGoals[0].item._id);
        if (isSavedGoal && this.state.isEdited) {
            saveGoalList = this.props.patientGoals;
        } else {
            _.map(this.state.updatedGoals, function(updatedGoalItem: {item: UserGoalView}){
                if (!ModelFactory.isGoalItemEmpty(updatedGoalItem.item, goalsType)) {
                    let goalItem = updatedGoalItem.item;
                    if (goalItem.startEpoch === null) {
                        goalItem.startEpoch = new Date().getTime();
                        goalItem.endEpoch = new Date().getTime() + (EpochConstants.EPOCH_IN_AN_DAY * 30 * 12);
                    }
                    goalItem.isSelf = isSelf;
                    goalItem.secondaryUserId = secondaryUserId;
                    goalItem.editInfo = !_.isEmpty(goalItem.editInfo) && !_.isEmpty(goalItem.editInfo.nextStatus) ?  goalItem.editInfo : { nextStatus: "LIVE" };
                    goalItem.status = "DRAFT";
                    goalItem.userGoalType = goalsType;
                    goalItem.durationInDays = !_.isNull(goalItem.durationInDays) && goalItem.durationInDays !== undefined ? goalItem.durationInDays : 30 * 12;
                    if (goalsType === "OTHER") {
                        delete goalItem.userId;
                        delete goalItem.goalId;
                        delete goalItem.goalMetricTargets;
                    }
                    saveGoalList.push(goalItem);
                }
            })
        }
        return saveGoalList;
    }
    clearErrorMessage = () => {
        this.setState({
            error: "",
            errorDetails: ""
        })
    }
    render() {
        let isHealthTargetLoaded = this.state.isHealthTargetDataLoaded === LOADING_STATE.LOADED && this.state.isStaticGoalsAndMetricsLoaded === LOADING_STATE.LOADED;
        let titleToDisplay = !_.isEmpty(this.props.titleToDisplay) ? this.props.titleToDisplay : "Health Targets";
        let errorMessage = !_.isEmpty(this.state.error) ? this.state.error : null;
        let errorDetails = !_.isEmpty(this.state.errorDetails) ? this.state.errorDetails : "";
        return <div className={`health-target-container`}>
            {
                !_.isNull(errorMessage) &&
                <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}/>
            }
            {isHealthTargetLoaded && <EditViewCard cardTitleDisplay={titleToDisplay} templateName={"healthTarget"}
                   templateProps={this.getHealthTargetEditViewProps()}
                   lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveHealthTarget}
                   cancelActionHandler={this.cancelActionHandler}
                   displayMode={this.props.displayMode}
            />}
            {!isHealthTargetLoaded && <AppLoader/>}
        </div>
    }
}